import { render } from "./modal-technicien.vue?vue&type=template&id=b1c18f24"
import script from "./modal-technicien.vue?vue&type=script&lang=js"
export * from "./modal-technicien.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__